module.exports = __webpack_public_path__ + "img/benoit5.6cefb5b6.jpg";